import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Notifications Component
 */
let NotificationsComponent = class NotificationsComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.notifications = {};
        this.saved = false;
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.textColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        localStorage.removeItem('draftData');
        this.httpClient.get('user/getselectednotifications').subscribe((result) => {
            this.notifications = result;
        });
    }
    updateNotification() {
        if (this.notifications.service_information_sms === false) {
            this.notifications.service_information_sms = 0;
        }
        if (this.notifications.newsletter === false) {
            this.notifications.newsletter = 0;
        }
        if (this.notifications.transactions_sms === false) {
            this.notifications.transactions_sms = 0;
        }
        this.httpClient.post('user/updatenotifications', this.notifications).subscribe((result) => {
            this.saved = true;
            setTimeout(function () {
                this.saved = false;
            }.bind(this), 2000);
        });
    }
};
NotificationsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
NotificationsComponent = __decorate([
    Component({
        selector: 'ecd-notifications',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./notifications.component.html")).default
    })
], NotificationsComponent);
export { NotificationsComponent };
